import {
  getObbBettingPrimeLegs,
  getObbCombinedLegFailures,
} from "@ppb/tbd-store/state/betting/obb-betting/obb-betting-selectors";
import { createSimpleSelectionsCounterSelector } from "@ppb/tbd-store/state/betting/sportsbook-betting/sportsbook-betting-selectors";
import { getSportsbookBettingImplyRunnerFailures } from "../../../../store/state/sportsbook-betting/sportsbook-betting-selectors";
import { BetslipType } from "../../../../constants";
import { MapStateToPropsFactory } from "react-redux";

import { COMBINED_LEGS_FAILURES_BLOCKLIST } from "@ppb/tbd-store/state/betting/obb-betting/obb-betting.constants";
import { BetslipApplicationState } from "../../../../store/state/BetslipApplicationState";
import { getIsBetslipLoaded } from "../../../../store/state/betslip-module/betslip-module-selectors";
import { getActiveBetslipType } from "../../../../store/state/betslip-type-selectors";
import { hasSGMFailures } from "../../../connected-sportsbook-betslip-mapper";
import { createMinimizedTitleSelector } from "../../vm-builder";
import type { BetslipLocalization, SportsbookBetslipPreferences } from "../../../../contract";

export type CardProps = {
  title: string | null;
  activeBetslipType: BetslipType | null;
  totalSelections: number;
  hasFailures?: boolean;
  isConfirm: boolean;
};
export type StateProps = CardProps | Record<string, never>;

export type DispatchProps = {};
export type ContainerProps = {
  onClick: () => void;
  localization: BetslipLocalization;
  preferences: SportsbookBetslipPreferences;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  const getSportsbookSimpleSelectionsCounter = createSimpleSelectionsCounterSelector();
  const buildTitle = createMinimizedTitleSelector();

  return (state: BetslipApplicationState, { localization, preferences }: ContainerProps): StateProps => {
    if (!getIsBetslipLoaded(state)) {
      return {};
    }

    const step = state.betslipModule?.step;
    const activeBetslipType = getActiveBetslipType(state);

    let totalSelections = 0;
    let hasFailures = false;

    if (activeBetslipType === BetslipType.OBB) {
      totalSelections = Object.keys(getObbBettingPrimeLegs(state)).length;
      hasFailures = Object.values(getObbCombinedLegFailures(state)).some((legFailure) =>
        COMBINED_LEGS_FAILURES_BLOCKLIST.includes(legFailure),
      );
    } else {
      totalSelections = getSportsbookSimpleSelectionsCounter(state);

      const failedRunners = getSportsbookBettingImplyRunnerFailures(state);
      hasFailures = Object.keys(failedRunners).some((key) => hasSGMFailures(failedRunners[key]));
    }

    return {
      title: buildTitle(state, localization, preferences.oddsDisplay),
      activeBetslipType,
      isConfirm: step === "CONFIRM_POTENTIAL",
      hasFailures,
      totalSelections,
    };
  };
};

export const mapDispatchToProps = {};
